const RESOLVERS = {
    API: "api",
    CHANGE: "change",
    ADD: "add",
    REMOVE: "remove",
    ADDOPTIONS: "addopt",
    REMOVEOPTIONS: "removeopt",
}

export default RESOLVERS;